export const Auth = {
  ACCESS_TOKEN_KEY: 'ACCESS_TOKEN_KEY',
  ACCESS_TOKEN_EXPIRY_KEY: 'ACCESS_TOKEN_EXPIRY_KEY',
  REFRESH_TOKEN_KEY: 'REFRESH_TOKEN_KEY'
};
